import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { DEMO_TOKENS, DEMO_USER, IS_DEMO } from '../demo/config.js';

export interface SessionUser {
  id: string;
  name: string;
  email: string;
  phone: string;
  role: 'rider' | 'driver' | 'admin';
}

interface SessionState {
  user: SessionUser | null;
  accessToken: string | null;
  refreshToken: string | null;
  setSession: (input: { user: SessionUser; accessToken: string; refreshToken: string }) => void;
  setTokens: (tokens: { accessToken: string; refreshToken: string }) => void;
  clear: () => void;
}

const initial: Pick<SessionState, 'user' | 'accessToken' | 'refreshToken'> = IS_DEMO
  ? { user: DEMO_USER, accessToken: DEMO_TOKENS.accessToken, refreshToken: DEMO_TOKENS.refreshToken }
  : { user: null, accessToken: null, refreshToken: null };

export const useSession = create<SessionState>()(
  persist(
    (set) => ({
      ...initial,
      setSession: ({ user, accessToken, refreshToken }) => set({ user, accessToken, refreshToken }),
      setTokens: ({ accessToken, refreshToken }) => set({ accessToken, refreshToken }),
      clear: () => set(IS_DEMO ? initial : { user: null, accessToken: null, refreshToken: null }),
    }),
    {
      name: 'raahi-rider-session',
      // In demo mode every visitor should land on the canned session, so we don't
      // restore a stale one that might have been left in localStorage by an earlier
      // build of the same domain.
      version: IS_DEMO ? 2 : 1,
    },
  ),
);
